var map = {
	"./configure-sso-de.html": 1316,
	"./configure-sso-en.html": 1317,
	"./configure-sso-es.html": 1318,
	"./configure-sso-fr.html": 1319,
	"./configure-sso-ja.html": 1320,
	"./configure-sso-pt.html": 1321,
	"./configure-sso-zh.html": 1322
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1315;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/manage-application/integration-developers/configure-sso ^\.\/configure\-sso\-.*\.html$
// module id = 1315
// module chunks = 0